<template>
    <section>
        <div
            class="fixed top-0 left-0 w-full h-full bg-brand-neutral-7/50 z-[200]"
            @click="$emit('close')"
        ></div>
        <div
            class="fixed left-0 bottom-0 w-full md:w-96 md:left-1/2 md:-translate-x-1/2 h-[90vh] z-[201]"
        >
            <div class="bg-white rounded-xl shadow-md h-full overflow-auto">
                <Button
                    @click="$emit('close')"
                    class="w-12 h-12 ml-4 mt-6 rounded-full"
                    variant="tertiary"
                >
                    <span
                        class="fi fi-sr-angle-small-down text-2xl flex"
                    ></span>
                </Button>
                <slot></slot>
            </div>
        </div>
    </section>
</template>
